/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useSupportConfigurationPageStyles = makeStyles(theme => ({
  input: {
    '& .MuiInputBase-input': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  subtitle: {
    color: '#1F3F6D',
    fontSize: '18px',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(0.5),
  },
  title: {
    marginTop: '5px',
    marginBottom: theme.spacing(3),
  },
}));
